import { createFileRoute } from "@tanstack/react-router";
import HomePage from "@project/user/pages/home/index";

export const Route = createFileRoute("/_user/")({
  head: () => ({
    meta: [
      { title: "Jivandhara Old Age Home — Trust, Seva & Care" },
      {
        name: "description",
        content:
          "A home of dignity, care and compassion for elderly residents. Donate, adopt a resident, or join our seva community.",
      },
    ],
  }),
  component: HomePage,
});
